<template>
  <div id="coupon-label" @click="showCoupons">
    <template v-if="terminal=='app'">
      <div class="app-coupon-label">
        <span class="text">{{text}}</span>
      </div>
    </template>
    <template v-else>
      <div class="pc-coupon-label">
        <div class="coupon">
          {{text}}
        </div>
        <div class="text">
          领取
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'CouponLabel',
    props: {
      text: {
        type: String,
        default () {
          return '满100减20'
        }
      },
      terminal: {
        type: String,
        default () {
          return 'app'
        }
      }
    },
    methods: {
      showCoupons() {
        this.$emit('showCoupons')
      }
    }
  }
</script>

<style lang="less" scoped>
  #coupon-label {
    cursor: pointer;

    .app-coupon-label {
      display: inline-block;
      color: #FF3939;
      font-size: 0.2rem;
      // border-top:1px solid #FF3939;
      // border-bottom:1px solid #FF3939;
      line-height: 0.37rem;
      height: 0.37rem;
      padding: 0 0.1rem;
      min-width: 0.6rem;
      text-align: center;
      position: relative;
      background: url('../assets/coupon/content-bg.png')no-repeat;
      background-size: 100% 0.37rem;
      text-align: center;

      &::before {
        content: '';
        position: absolute;
        left: -0.05rem;
        width: 0.08rem;
        height: 0.37rem;
        top: 0;
        background: url('../assets/coupon/left-bg.png')no-repeat;
        background-size: 0.08rem 0.37rem;
      }

      &::after {
        content: '';
        position: absolute;
        right: -0.05rem;
        width: 0.08rem;
        height: 0.37rem;
        top: 0;
        background: url('../assets/coupon/right-bg.png')no-repeat;
        background-size: 0.08rem 0.37rem;
      }
    }

    .pc-coupon-label {
      display: flex;
      flex-direction: row;


      >.coupon {
        background: #FFE4E5;
        border: 1px #FF3939 solid;
        border-right: 0;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 57, 57, 1);
        line-height: 17px;
        padding: 3px 8px;
        position: relative;

        &::after {
          content: '';
          background: #FFE4E5 url('../assets/coupon/c-split.png') no-repeat center;
          background-size: cover;
          width: 10px;
          height: 25px;
          position: absolute;
          top: -1px;
          right: -5px;
        }
      }

      >.text {
        background: #FFE4E5;
        border: 1px #FF3939 solid;
        border-left: 0;
        color: rgba(255, 57, 57, 1);
        font-size: 12px;
        font-weight: 400;
        margin-left: 4px;
        padding: 3px 8px;
      }
    }
  }
</style>